import React, { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import WalletCard from "../../components/RetailerBusinessAgent/WallertCard";
import WelcomeModal from "../../components/RetailerBusinessAgent/WelcomeModal";
import { API_URL } from "../../constant";
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import wallet1 from "../../images/shapes/Wallet01 5.png";
import dollarY from "../../images/shapes/Dollar Bag (1).png";
import dollarG from "../../images/shapes/Dollar Bag.png";
import oldbank from "../../images/shapes/bank-pound-icon2 4.png";
import history1 from "../../images/shapes/Group 37483.png";

const MemberWallet = () => {
  const navigate = useNavigate();
  const { userData } = useOutletContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [walletData, setWalletData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [containerStyle, setContainerStyle] = useState({});

  useEffect(() => {
    if (!userData) {
      navigate("/member-login");
      return;
    }

    setContainerStyle(getContainerStyle());
    fetchWalletData();
  }, [userData, navigate]);

  const getContainerStyle = () => {
    return {
      display: "flex",
      flexDirection: "column",
      marginTop: "0px",
      marginBottom: "0px",
      background: "linear-gradient(to bottom, #1a5276, white)",
      width: "100%",
      minHeight: "130vh",
      fontFamily: "'Poppins', sans-serif",
      padding: "20px",
    };
  };

  // Check if modal has been shown before for this user
  const hasModalBeenShown = () => {
    const userId = userData?.id || userData?.email;
    if (!userId) return false;

    const shownModals = JSON.parse(
      localStorage.getItem("shown_welcome_modals") || "{}"
    );
    return shownModals[userId] === true;
  };

  // Mark modal as shown for this user
  const markModalAsShown = () => {
    const userId = userData?.id || userData?.email;
    if (!userId) return;

    const shownModals = JSON.parse(
      localStorage.getItem("shown_welcome_modals") || "{}"
    );
    shownModals[userId] = true;
    localStorage.setItem("shown_welcome_modals", JSON.stringify(shownModals));
  };

  const fetchWalletData = async () => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      navigate("/member-login");
      return;
    }

    setIsLoading(true);
    try {
      const walletResponse = await fetch(`${API_URL}/api/member/wallet`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!walletResponse.ok) throw new Error("Failed to fetch wallet data");
      const walletResult = await walletResponse.json();

      setWalletData({
        points: walletResult.wallet?.units || 0,
        cashBalance: walletResult.secondary_wallet?.units || 0,
        earnedBonusCash: walletResult.earned_bonus_reward_wallet?.cash ?? 0,
        transactions: walletResult.transactions || [],
      });

      // Check if modal should be shown for this user
      const userId = userData?.id || userData?.email;
      if (userId && !hasModalBeenShown()) {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching wallet data:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    markModalAsShown();
  };

  if (isLoading) {
    return (
      <div
        style={{
          ...containerStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ marginTop: "20px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #3498db",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          ...containerStyle,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ color: "red" }}>Error: {error}</div>
      </div>
    );
  }

  if (!walletData) {
    return null;
  }

  // Prepare user data for modal
  const modalUserData = {
    firstName: userData?.firstName || "Member",
    sureName: userData?.sureName || "",
    fullName: userData?.fullName || "Member",
    role: userData?.role || "Member",
    avatar: userData?.avatar || "",
    email: userData?.email || "",
    id: userData?.id || "",
  };

  return (
    <div style={{ ...containerStyle, height: "auto" }}>
      <div className="wallet-container1">
        {/* TopCoin Wallet */}
        <WalletCard
          imgH={wallet2}
          imgT={dollarG}
          imgHi={history1}
          title="TopCoin Wallet (Member)"
          amount={`${walletData.points}`}
          subText="Available TopCoin"
          bgColor="#f0fdf4"
          historyLink=""
          bgColor1="#dcfce7"
          onHistoryClick={() => navigate("")}
        />

        {/* Earned Bonus Reward Wallet */}
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Earned Bonus Reward Wallet (Member)"
          amount={`£ ${parseFloat(walletData.earnedBonusCash || 0).toFixed(2)}`}
          subText="Cash Reward"
          bgColor="#fff7ed"
          bgColor1="#ffedd5"
          historyLink=""
          onHistoryClick={() => navigate("")}
        />

        {/* Withdraw Card - Disabled/Grayed out */}
        <WalletCard
          imgH={oldbank}
          imgT={dollarY}
          title="Withdrawal"
          amount={`£ ${(0).toFixed(2)}`}
          subText="Available Cash"
          bgColor="#f5f5f5"
          bgColor1="#e0e0e0"
          historyLink="#"
          buttonText="Withdraw"
          disabled={true}
          showButton={true}
        />
      </div>

      {/* Welcome Modal */}
      {showModal && (
        <WelcomeModal user={modalUserData} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default MemberWallet;
